/**
 * Gallery Images reducer.
 * @module reducers/content_types/pages
 */

 import { map } from 'lodash';
//  import { settings } from '~/config';

 import { GET_PAGES } from '../../constants/ActionTypes';

 const initialState = {
   success: undefined,
   error: null,
   loaded: false,
   loading: false,
   searchString: null,
   pages: [],
   latestUpdate: 0
 };

 /**
  * Faq reducer.
  * @function pages
  * @param {Object} state Current state.
  * @param {Object} action Action to be handled.
  * @returns {Object} New state.
  */
 export default function pages(state = initialState, action = {}) {
   switch (action.type) {
     case `${GET_PAGES}_PENDING`:
       return {
         ...state,
         success: undefined,
         error: "LOADING PAGES",
         loading: true,
         loaded: false,
         searchString: action.request,
         pages: [],
       };
     case `${GET_PAGES}_SUCCESS`:
       const results = action.result.items;
       
       return {
         ...state,
          success: true,
          error: "DATA RECEIVED SUCCESSFULLY",
          loaded: true,
          loading: false,
          pages: results,
          latestUpdate: Date.now()
       };

     case `${GET_PAGES}_FAIL`:
      //  console.log(">>>>>>>>>>>>>>> GET_PAGES_FAIL");
       return {
         ...state,
         success: false,
         error: action.error,
         loading: false,
         loaded: false,
         pages: [],
         latestUpdate: 0
       };
     default:
       return state;
   }
 }